import { MessageCircle } from "lucide-react";

const TEXT =
  "Bonjour, je vous contacte depuis la page Maroc Surfing concernant vos services...";
const HREF = `https://wa.me/212706280215?text=${encodeURIComponent(TEXT)}`;

const SurfWaveWhatsApp = () => {
  return (
    <a
      href={HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter Maroc Surfing sur WhatsApp"
      className="surf-wave-cta fixed bottom-5 right-5 z-50 group"
    >
      <span className="surf-wave-ring" aria-hidden />
      <span className="surf-wave-ring surf-wave-ring--2" aria-hidden />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold pl-4 pr-5 py-3 rounded-full shadow-xl ring-2 ring-white">
        <span className="relative w-5 h-5 inline-flex items-center justify-center">
          <MessageCircle className="w-5 h-5" />
        </span>
        <span className="hidden sm:inline">WhatsApp</span>
        <svg
          aria-hidden
          viewBox="0 0 80 14"
          className="absolute left-3 right-3 -bottom-1 h-2 w-[calc(100%-1.5rem)] text-white/70"
        >
          <path
            d="M0 7 Q 10 0 20 7 T 40 7 T 60 7 T 80 7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            className="surf-wave-path"
          />
        </svg>
      </span>
    </a>
  );
};

export default SurfWaveWhatsApp;